export const auth = {
  login: "تسجيل الدخول",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  rememberMe: "تذكرني",
  emailPlaceholder: "أدخل البريد الالكتروني",
  passwordPlaceholder: "أدخل كلمة المرور",
  validations: {
    emailReq: "البريد الإلكتروني مطلوب",
    emailValid: "برجاء إدخال بريد إلكتروني صحيح",
    passwordReq: "كلمة المرور مطلوبة",
    req: "مطلوب",
    confirmPasswordRequired: "تأكيد كلمة المرور مطلوب",
    passowrdCriteria:
      "يجب أن تحتوي كلمة المرور على 10 أحرف على الأقل، ومزيج من الأحرف (أحرف كبيرة وصغيرة)، وأرقام، وأحرف خاصة",
    passwordsMustMatch: "يجب أن تتطابق كلمة المرور وتأكيد كلمة المرور",
  },
  activateAccount: {
    accountActivation: "تفعيل الحساب",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور",
    confirmPasswordPlaceholder: "أدخل تأكيد كلمة المرور",
    activate: "تفعيل",
    goToLogin: "الرجوع لتسجيل الدخول",
  },
  resetPassword: {
    resetPassword: "إعادة تعيين كلمة المرور",
    reset: "إعادة تعيين",
  },
  messages: {
    activateAccount: "تم تفعيل حسابك بنجاح",
    resetPassword: "تم إعادة تعيين كلمة المرور بنجاح",
  },
};
